export const userErrorsObject = /* GraphQL */ `
userErrors {
  message
  code
  field
}
`;
